import React, { useState, createContext, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  const updateCart = (newCart)=>{
    setCart(newCart);
    sessionStorage.setItem('cart', JSON.stringify(newCart));
  }
  useEffect(() => {
    const sessionCart =  JSON.parse(sessionStorage.getItem('cart')) || [];
    setCart(sessionCart);
  }, []);

  return <CartContext.Provider value={{cart, updateCart}}>{children}</CartContext.Provider>;
};
